// ** React Imports
import {Fragment, useEffect, useState} from 'react'

// ** Table Data & Columns
import {columns} from './data'

// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown, Edit3, FolderPlus, Send, Triangle, Users, XCircle} from 'react-feather'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, CardText

} from 'reactstrap'

import '@styles/react/libs/tables/react-dataTable-component.scss'

import axios from "axios";
import moment from "moment";
import Timeline from '@components/timeline';
import {countryOptions, documentStatusGlobal, documentStatusUrlMap} from "../../../utility/helpers";
import {useParams} from "react-router-dom";
import Select from "react-select";
import AreaFilter from "../area/components/filter-area/area-filter";
import DocumentsListFilter from "./document-list-filter";

const MySwal = withReactContent(Swal)

const DocumentsList = () => {
    // ** States
    const params = useParams();
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data)
    const [totalRecords, setTotalRecords] = useState(0);
    const [documentStatusDefinition] = useState(documentStatusGlobal);

    const [modal, setModal] = useState(false);
    const [loadModal, setLoadModal] = useState(false);

    const [timeLineData, setTimeLineData] = useState([]);
    const [documentModal, setDocumentModal] = useState('');
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [filterData, setFilterData] =
        useState({pageNumber: 1, pageSize: 25, status: +params.statusDocument});

    const handleAreaChange = (selectedOptions) => {
        setSelectedAreas(selectedOptions);
    };

    const onFilter = (filterProp) => {
        setFilterData({...filterData, ...filterProp});
    }

    useEffect(() => {
        getDocuments();
    }, [filterData]);

    useEffect(() => {
        getAreas();
    }, []);

    const getAreas = async () => {
        const areasUrl = `${process.env.REACT_APP_API_URL}/areas/assigned`;
        const response = await axios.get(areasUrl);
        let areaList = response?.data.data;

        areaList = areaList.map(area => {
            return {
                value: area.id,
                label: area.name
            }
        })
        setAreaList(areaList);
    }

    const checkIfCancellationEnabled = (itemId) => {
        const role = JSON.parse(localStorage.getItem("userData"))?.role?.toLowerCase();
        if (role) {
            switch (role) {
                case 'administrador': return true;
                case 'supervisor': {
                    return areaList.map(area => area.label).includes(data.find(d => d.noDocument === itemId)?.area);
                }
                case 'agente': {
                    return areaList.map(area => area.label).includes(data.find(d => d.noDocument === itemId)?.area);
                }
                case 'consultor': {
                    return false;
                }
                default: return false;
            }
        }

        if (role) {
            return !role?.startsWith("admin");
        }
        return false;
    }

    const getDocuments = async () => {

        console.log(filterData)
        const documentsUrl = `${process.env.REACT_APP_API_URL}/documents/getAll`;
        const response = await axios.post(documentsUrl, {
            ...filterData,
            pageNumber: +currentPage + 1
        });

        const documentsList = response.data.data
            .map(item => {
                return {
                    noDocument: item.id,
                    clientName: item.clientName,
                    createDate: moment(item.createdAt).format("DD/MM/YYYY hh:mm a"),
                    documentUrl: item.url,
                    documentName: item.title,
                    clientEmail: item.clientEmail,
                    clientPhone: item.clientPhone,
                    area: item.area,
                    clientIdentification: item.clientIdentification,
                    society: item.society,
                }
            });
        setData(documentsList);
        setTotalRecords(response.data.totalRecords);
    }

    useEffect(() => {
        getDocuments();
    }, []);

    const formatDate = (dateString) => {
        // Eliminar milisegundos y cualquier parte extra
        const cleanDateString = dateString.split('.')[0]; // Quedarse solo con la parte principal
    
        const date = new Date(cleanDateString); // Convierte la cadena a un objeto Date
        const day = String(date.getDate()).padStart(2, '0'); // Día con 2 dígitos
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Mes con 2 dígitos (0-indexado)
        const year = date.getFullYear(); // Año completo
        const hours = String(date.getHours()).padStart(2, '0'); // Hora con 2 dígitos
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Minutos con 2 dígitos
        
        return `${day}/${month}/${year} ${hours}:${minutes}`; // Formato dd/mm/yyyy hh:mm
    };

    const getDocumentTracking = async (document) => {
        console.log("DOCUMENT: ", document);
        setLoadModal(true);
        setDocumentModal(document);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/documents/timeline/${document.id}`);

        console.log(response);
        const timeLineTracking = [];
        response.data?.data?.forEach((item) => {

            if (item.status === documentStatusDefinition.created) {
                timeLineTracking.push({
                    title: 'Borrador',
                    content: 'El documento se encuentra en borrador',
                    icon: <FolderPlus size={14}/>,
                    meta: moment(item.creationDate).format("DD/MM/YYYY hh:mm a"),
                    color: 'info',
                    customContent: ''
                })
            }

            if (item.status === documentStatusDefinition.sent) {
                timeLineTracking.push({
                    title: 'Enviado',
                    content: 'El documento ha sido enviado',
                    icon: <Send size={14}/>,
                    meta: moment(item.creationDate).format("DD/MM/YYYY hh:mm a"),
                    color: 'success',
                    customContent: ''
                })
            }

            if (item.status === documentStatusDefinition.signed) {
                timeLineTracking.push({
                    title: 'Firmado',
                    content: 'El documento ha sido firmado',
                    icon: <Edit3 size={14}/>,
                    meta: moment(item.creationDate).format("DD/MM/YYYY hh:mm a"),
                    color: 'primary',
                    customContent: ''
                })
            }

            if (item.status === documentStatusDefinition.refused) {
                timeLineTracking.push({
                    title: 'Rechazado',
                    content: 'El documento ha sido rechazado',
                    icon: <XCircle size={14}/>,
                    meta: moment(item.creationDate).format("DD/MM/YYYY hh:mm a"),
                    color: 'danger',
                    customContent: (
                        <Fragment>
                            <hr/>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex flex-wrap align-items-center mt-sm-0 mt-50'>
                                    <strong className={'pe-1'}>Motivo de rechazo:</strong>
                                    {item.observation}
                                </div>
                            </div>
                        </Fragment>
                    )
                })
            }

            if (item.status === documentStatusDefinition.canceled) {

                setDocumentModal((prev) => ({...prev, canceled: true}));
                timeLineTracking.push({
                    title: 'Anulado',
                    content: 'El documento ha sido anulado',
                    icon: <Triangle size={14}/>,
                    meta: moment(item.creationDate).format("DD/MM/YYYY hh:mm a"),
                    color: 'danger',
                    customContent: (
                        <Fragment>
                            <hr/>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex flex-wrap align-items-center mt-sm-0 mt-50'>
                                    <strong className={'pe-1'}>Motivo de anulación:</strong>
                                    {item.observation}
                                </div>
                            </div>
                            <hr/>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex flex-wrap align-items-center mt-sm-0 mt-50'>
                                    <strong className={'pe-1'}>Usuario:</strong>
                                    {item?.changedBy || 'API'}
                                </div>
                            </div>
                        </Fragment>
                    )
                })
            }
        });

        if (document.society) {
            const societyTimeLine = await axios.get(`${process.env.REACT_APP_API_URL}/signatoriesSocieties/timeline/${document.id}`);
            console.log("SOCIETY TIMELINE: ", societyTimeLine);
            timeLineTracking.push({
                title: 'Detalles de sociedad',
                content: 'firmantes:',
                icon: <Users size={14}/>,
                meta: moment(new Date()).format("DD/MM/YYYY hh:mm a"),
                color: 'info',
                customContent: (
                        societyTimeLine?.data?.data?.map((item) => {
                            return (
                                <Fragment>
                                    <div className='d-flex justify-content-between flex-wrap'>
                                        <ul className='d-flex flex-wrap align-items-center mt-sm-0 mt-50'>
                                            <li key={item.id}>
                                            {item.name} : {item.status ? `Firmado - ${new Date(`${item.signedAt  }Z`).toLocaleString()}`: "Pendiente"}
                                            </li>
                                        </ul>
                                    </div>
                                </Fragment>
                            )
                        })
                )
            })
        }

        setTimeLineData(timeLineTracking);
        setLoadModal(false);
    }
    const toggleModal = (show, document) => {
        setModal(show);
        if (show && document) {
            getDocumentTracking(document);
        }
    }

    const cancelDocument = async () => {
        setLoadModal(true);
        const {value: comment} = await MySwal.fire({
            title: 'Desea anular el documento?',
            input: 'textarea',
            inputLabel: 'Razón de anulación del documento?',
            inputPlaceholder: 'Agrega un comentario...',
            inputAttributes: {
                'aria-label': 'Type your message here',
                'style': 'margin: 20px;'
            },
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value.trim() !== '') {
                        resolve()
                    } else {
                        resolve('La razón es obligatoria')
                    }
                })
            },
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Anular',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-warning',
                cancelButton: 'btn btn-outline-primary ms-1'
            },
            buttonsStyling: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                const documentInfoUrl = `${process.env.REACT_APP_API_URL}/documents/cancel`;
                await axios.post(documentInfoUrl, {
                    documentId: documentModal.id,
                    observation: result?.value || "HARD CANCELLATION"
                });
                setLoadModal(false);
                window.location.reload();
            } else {
                window.location.reload();
            }
        })

    }

    // const cancelDocument = async () => {
    //     setLoadModal(true);
    //     const documentInfoUrl = `${process.env.REACT_APP_API_URL}/documents/${documentModal.id}`;
    //     const getDocumentInfo = await axios.get(documentInfoUrl);
    //
    //     const clientsUrl = `${process.env.REACT_APP_API_URL}/clients`;
    //     const getClients = await axios.get(clientsUrl);
    //     const filterClient = getClients?.data?.find(item => item.id === getDocumentInfo.data.clientId)
    //
    //     if (filterClient?.documentClient) {
    //         setLoadModal(false);
    //         const {value: comment} = await MySwal.fire({
    //             title: 'Desea anular el documento?',
    //             input: 'textarea',
    //             inputLabel: 'Razón de anulación del documento?',
    //             inputPlaceholder: 'Agrega un comentario...',
    //             inputAttributes: {
    //                 'aria-label': 'Type your message here',
    //                 'style': 'margin: 20px;'
    //             },
    //             inputValidator: (value) => {
    //                 return new Promise((resolve) => {
    //                     if (value.trim() !== '') {
    //                         resolve()
    //                     } else {
    //                         resolve('La razón es obligatoria')
    //                     }
    //                 })
    //             },
    //             icon: 'warning',
    //             showCancelButton: true,
    //             confirmButtonText: 'Anular',
    //             cancelButtonText: 'Cancelar',
    //             customClass: {
    //                 confirmButton: 'btn btn-warning',
    //                 cancelButton: 'btn btn-outline-primary ms-1'
    //             },
    //             buttonsStyling: false
    //         });
    //         if (comment) {
    //             setLoadModal(true);
    //             const data = {
    //                 client_id: filterClient.documentClient,
    //                 company_name: getDocumentInfo.data.url.split('/')[4],
    //                 document_name: documentModal.name,
    //                 document_id: documentModal.id,
    //                 observation: comment
    //             }
    //             const resultDocument = async () => {
    //                 return await axios.post(
    //                     `${process.env.REACT_APP_API_NODE_URL}/cancel/document`,
    //                     data);
    //             }
    //
    //             resultDocument().then(async res => {
    //                 setLoadModal(false);
    //                 if (res.data.documentName) {
    //                     await MySwal.fire({
    //                         title: 'Documento Anulado',
    //                         html: `Documento ${res.data.documentName} se ha anulado. <span style="display: block; position: relative; margin-top: 10px">
    //                     <b>Causa: </b> ${comment}
    //                     </span> <hr>`,
    //                         icon: 'warning',
    //                         showCloseButton: false,
    //                         showCancelButton: false,
    //                         confirmButtonText: 'Aceptar',
    //                         customClass: {
    //                             confirmButton: 'btn btn-warning'
    //                         },
    //                         buttonsStyling: false,
    //                         allowEscapeKey: false,
    //                         allowOutsideClick: false
    //                     }).then((result) => {
    //                         if (result.isConfirmed) {
    //                             window.location.reload();
    //                         }
    //                     })
    //                 }
    //             }).catch(async err => {
    //                 setLoadModal(false);
    //                 await MySwal.fire({
    //                     title: 'Error al anular el documento',
    //                     html: `El documento no se ha logrado anular. <span style="display: block; position: relative; margin-top: 10px">
    //                     <b>Causa: </b> ${err.data}
    //                     </span> <hr>`,
    //                     icon: 'danger',
    //                     showCloseButton: false,
    //                     showCancelButton: false,
    //                     confirmButtonText: 'Aceptar',
    //                     customClass: {
    //                         confirmButton: 'btn btn-danger'
    //                     },
    //                     buttonsStyling: false,
    //                     allowEscapeKey: false,
    //                     allowOutsideClick: false
    //                 }).then((result) => {
    //                     if (result.isConfirmed) {
    //                         window.location.reload();
    //                     }
    //                 })
    //             })
    //         }
    //     } else {
    //         setLoadModal(false);
    //         await MySwal.fire({
    //             title: 'Error al anular el documento',
    //             html: `El documento no se ha logrado anular. <span style="display: block; position: relative; margin-top: 10px">
    //                     <b>Causa: </b> Fallo al obtener número de identificación del cliente <b>${filterClient.firstName} ${filterClient.lastName}</b>
    //                     </span> <hr>`,
    //             icon: 'danger',
    //             showCloseButton: false,
    //             showCancelButton: false,
    //             confirmButtonText: 'Aceptar',
    //             customClass: {
    //                 confirmButton: 'btn btn-danger'
    //             },
    //             buttonsStyling: false,
    //             allowEscapeKey: false,
    //             allowOutsideClick: false
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 window.location.reload();
    //             }
    //         })
    //     }
    //
    // }

    // ** Function to handle filter
    const handleFilter = e => {
        const value = e.target.value;
        let updatedData = [];
        setSearchValue(value)

        if (value.length) {
            updatedData = data.filter(item => {

                const startsWith =
                    item.noDocument.toString().toLowerCase().startsWith(value.toLowerCase()) ||
                    item.clientName.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.createDate.toLowerCase().startsWith(value.toLowerCase()) ||
                    item.documentUrl.toLowerCase().startsWith(value.toLowerCase())

                const includes =
                    item.noDocument.toString().toLowerCase().includes(value.toLowerCase()) ||
                    item.clientName.toLowerCase().includes(value.toLowerCase()) ||
                    item.createDate.toLowerCase().includes(value.toLowerCase()) ||
                    item.documentUrl.toLowerCase().includes(value.toLowerCase())

                if (startsWith) {
                    return startsWith
                } else if (!startsWith && includes) {
                    return includes
                } else return null
            })
            setFilteredData(updatedData)
            setSearchValue(value)
        }
    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected);
    }

    useEffect(() => {
        getDocuments();
    }, [currentPage]);

    // ** Pagination Previous Component
    const Previous = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous/>}
            nextLabel={<Next/>}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={Math.ceil(totalRecords / 25)}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (
        <Fragment>
            <DocumentsListFilter onFilter={onFilter} />
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Documentos</CardTitle>
                </CardHeader>

                <div className={`react-dataTable`}>
                    <DataTable
                        noHeader
                        pagination
                        columns={columns(toggleModal)}
                        paginationPerPage={25}
                        className='react-dataTable'
                        responsive={true}
                        sortIcon={<ChevronDown size={10}/>}
                        paginationComponent={CustomPagination}
                        paginationDefaultPage={currentPage + 1}
                        data={searchValue.length ? filteredData : data}
                    />
                </div>
            </Card>
            <Modal
                key={documentModal.id}
                isOpen={modal}
                toggle={() => toggleModal(false)}
                className={`modal-dialog-centered `}
            >
                <ModalHeader toggle={() => toggleModal(false)}>
                    Linea de tiempo: {documentModal.name}
                </ModalHeader>
                <ModalBody>
                    {loadModal && <div className='row'>
                        <div className='col-12 px-2 py-4 text-center'>
                            <Spinner size='lg'/>
                            <CardText className={'py-1 fs-5'}>Cargando...</CardText>
                        </div>
                    </div>
                    }
                    {!loadModal && (<Timeline className={'pt-2 pb-1'} data={timeLineData}/>)}
                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={() => toggleModal(false)}>
                        Aceptar
                    </Button>
                    {!documentModal.canceled && !loadModal && <Button color='warning' onClick={cancelDocument} outline disabled={!checkIfCancellationEnabled(documentModal.id)}>
                        Anular
                    </Button>}
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}

export default DocumentsList
